import React from 'react';
import { Clock, Archive, ChefHat, ShoppingCart, Leaf, Users, Check } from 'lucide-react';
import { motion } from 'framer-motion';
const tomos = [{
  num: 1,
  title: 'PROTOCOLO VACIADO 24 HORAS',
  subtitle: 'El Reseteo',
  desc: 'El protocolo hora por hora para bajar la hinchazón en un día. Lista de compras, bebidas de rescate, alimentos aliados y prohibidos, checklist completo y plan post-reseteo.',
  check: 'Para usar hoy mismo.',
  color: '#39B900',
  icon: Clock
}, {
  num: 2,
  title: 'EL LIMPIADOR DE ALACENA ARGENTINO',
  subtitle: 'Limpiá tu cocina. Limpiá tu panza.',
  desc: 'Cómo leer etiquetas en 30 segundos, identificar los alimentos inflamatorios que tenés guardados sin saberlo y hacer el cambio sin tirar todo a la basura.',
  check: 'El tomo que más sorprende.',
  color: '#9BEA00',
  icon: Archive
}, {
  num: 3,
  title: 'RECETARIO 15 MINUTOS DE ALIVIO',
  subtitle: 'Cocinás rápido. Te sentís bien.',
  desc: 'Recetas anti-inflamatorias listas en 15 minutos o menos con ingredientes de cualquier supermercado argentino. Sin ingredientes raros. Sin horas en la cocina.',
  check: 'El recetario que sí vas a usar.',
  color: '#00C7D9',
  icon: ChefHat
}, {
  num: 4,
  title: 'PLANIFICADOR DE COMPRAS E INGENIERÍA DE PRECIOS',
  subtitle: 'Comer bien sin gastar de más.',
  desc: 'Cómo organizar las compras semanales para tener siempre lo correcto en casa, reducir el gasto y eliminar la improvisación que lleva a las malas decisiones.',
  check: 'El tomo más práctico del sistema.',
  color: '#FF7A00',
  icon: ShoppingCart
}, {
  num: 5,
  title: 'EL BOTIQUÍN DE INFUSIONES Y SUPLEMENTOS NATURALES',
  subtitle: 'Tu farmacia natural antiinflamatoria.',
  desc: 'Las 15 hierbas esenciales disponibles en Argentina, cómo prepararlas correctamente, para qué sirve cada una y cuándo usarlas según el síntoma.',
  check: 'El tomo que se convierte en consulta diaria.',
  color: '#39B900',
  icon: Leaf
}, {
  num: 6,
  title: 'GUÍA DE SUPERVIVENCIA SOCIAL',
  subtitle: 'Asados, cumpleaños y salidas sin arruinar todo.',
  desc: 'Cómo manejarte en situaciones sociales, restaurantes y eventos sin perder el progreso ni convertirte en el pesado del grupo.',
  check: 'La guía que hace el sistema sostenible.',
  color: '#FF2D7A',
  icon: Users
}];
const includes = ['Protocolo paso a paso listo para aplicar hoy', 'Tablas y checklists visuales', 'Explicación del mecanismo — por qué funciona', 'Adaptado 100% al contexto argentino', 'Ingredientes de cualquier supermercado', 'Sin tecnicismos ni lenguaje médico complicado', 'Resultados visibles en 24 a 72 horas'];
export function TomosGrid() {
  return <section className="py-20 px-4 bg-black border-t border-white/5" data-id="element-302">
      <div className="max-w-6xl mx-auto" data-id="element-303">
        <div className="mb-16" data-id="element-304">
          <p className="text-brand-green font-bold tracking-widest uppercase text-sm mb-4 flex items-center justify-center gap-2" data-id="element-305">
            MEGAPACK ANTI-INFLAMACIÓN
          </p>
          <h2 className="text-3xl sm:text-5xl font-extrabold text-white mb-6" data-id="element-306">
            PROTOCOLO RESETEO 24 HORAS
          </h2>
          <p className="text-xl font-medium text-gray-300" data-id="element-307">
            6 Tomos + 6 Bonos — Edición 2026 Argentina
          </p>
          <p className="mt-3 inline-block bg-gradient-to-r from-yellow-500 via-yellow-300 to-yellow-500 bg-clip-text font-extrabold tracking-wide drop-shadow-[0_0_15px_rgba(250,204,21,0.3)] text-[#38B900] text-[20px]" data-id="element-308">
            480+ páginas — Todo resuelto. Todo listo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-309">
          {tomos.map((tomo, i) => {
          const Icon = tomo.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 shadow-lg flex flex-col items-center h-full border border-white/10 relative overflow-hidden pt-[32px] pb-[32px] pl-[3px] pr-[3px]" style={{
            borderTop: `4px solid ${tomo.color}`
          }} data-id="element-310">
                <div className="w-16 h-16 rounded-2xl flex items-center justify-center text-white shadow-md mb-5" style={{
              backgroundColor: tomo.color
            }} data-id="element-311">
                  <Icon size={30} data-id="element-312" />
                </div>

                <p className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-2" data-id="element-313">
                  Tomo {tomo.num}
                </p>

                <h3 className="text-xl font-extrabold mb-2 leading-tight text-[#FAFAF7]" data-id="element-314">
                  {tomo.title}
                </h3>
                <p className="font-bold text-gray-300 mb-4 italic" data-id="element-315">
                  {tomo.subtitle}
                </p>

                <p className="text-gray-400 text-sm leading-relaxed mb-6 flex-grow" data-id="element-316">
                  {tomo.desc}
                </p>

                <div className="pt-4 border-t border-white/10 w-full flex items-center justify-center gap-2 mt-auto" data-id="element-317">
                  <Check size={18} style={{
                color: tomo.color
              }} className="shrink-0" strokeWidth={3} data-id="element-318" />
                  <span className="text-sm font-bold text-white" data-id="element-319">
                    {tomo.check}
                  </span>
                </div>
              </motion.div>;
        })}
        </div>

        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 sm:p-12 max-w-4xl mx-auto border border-white/10 pt-[3px] pb-[3px]" data-id="element-320">
          <h3 className="text-2xl font-bold text-white mb-8" data-id="element-321">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8" data-id="element-322">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-3 text-left" data-id="element-323">
                <div className="bg-brand-green/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-324">
                  <Check size={16} className="text-brand-green" strokeWidth={3} data-id="element-325" />
                </div>
                <span className="text-gray-200 font-medium" data-id="element-326">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}